/**
 * Helper function to get competitors search data from either source
 * @param {Object} historyResult - Data from history reducer
 * @param {Object} extendedAnalysisResults - Data from extended analysis reducer
 * @returns {Object|null} - Competitors search data or null if not available
 */
export const getCompetitorsSearchData = (historyResult, extendedAnalysisResults) => {
  // API always returns competitors_search_task, so check both sources for that field
  if (extendedAnalysisResults?.competitors_search_task) {
    return extendedAnalysisResults.competitors_search_task;
  }
  if (historyResult?.competitors_search_task) {
    return historyResult.competitors_search_task;
  }
  return null;
}; 